/**
 * iOS home-screen quick action bridge ("Add entry").
 *
 * AppDelegate.swift declares a static UIApplicationShortcutItems entry
 * ("Add entry") and, when the user long-presses the app icon and taps it
 * (cold or warm start), forwards it into the app as a synthetic deep-link
 * URL (`com.brokeornot.app://add-entry`) through `ApplicationDelegateProxy`.
 * That makes the already-linked `@capacitor/app` plugin fire its JS
 * `appUrlOpen` event, which this listener picks up to navigate to the
 * calendar and open the add-entry dialog.
 *
 * Native-only (isRunningInNativeShell() gated), following the same
 * boot-wiring pattern as nativeBack.ts.
 */
import type { AnyRouter } from '@tanstack/react-router';
import { App } from '@capacitor/app';
import { useCalendarStore } from '@/features/calendar/calendarStore';
import { isRunningInNativeShell } from './pwa';

export function registerNativeShortcuts(router: AnyRouter): void {
  if (!isRunningInNativeShell()) return;

  void App.addListener('appUrlOpen', (event) => {
    // Match the add-entry deep link defensively (URL is com.brokeornot.app://add-entry).
    if (!event.url?.includes('add-entry')) return;

    // Navigate to the calendar (index route) if we're not already there.
    if (router.state.location.pathname !== '/') {
      void router.navigate({ to: '/' });
    }

    useCalendarStore.getState().openAddEntry();
  });
}
